import Select from 'react-select';
import classnames from 'classnames';
import { Control } from '../components/control';
import { SingleValueBase as SingleValue } from '../components/value/base';
import { OptionBase as Option } from '../components/option/base';
import '../components/styles/default.scss';
import s from './index.module.scss';

export const BaseSelectField = ({
  label,
  value,
  error,
  name,
  className,
  onChange,
  options,
  ...props
}) => {
  return (
    <div className={className}>
      <Select
        value={value}
        onChange={onChange}
        name={name}
        classNamePrefix="scr_select"
        className={classnames(s.select, error && s.select_error)}
        options={options}
        components={{ Control, Option, SingleValue }}
        placeholder=""
        isSearchable
        aria-errormessage={error}
        aria-label={label}
        {...props}
      />
      {error && <div className={s.error_message}>{error}</div>}
    </div>
  );
};
